import React from "react";
import TicketForm from "../../../../components/ticket-form";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./index.scss";
import { useNavigate } from "react-router-dom";

const CreateTicket = () => {
  const navigate = useNavigate();
  return (
    <div className="page-body">
      <div className=" view-detailed-ticket">
        <ArrowBackIcon
          sx={{ cursor: "pointer", marginRight: "20px" }}
          onClick={() => {
            navigate(-1);
          }}
        />
        <div>
          <p className="tab-name">Service Support</p>
          <p className="section-name">Create service request</p>
        </div>
      </div>

      <div className="ct-form">
        <TicketForm />
      </div>
    </div>
  );
};

export default CreateTicket;
